const ROW_CONTROL_SELECTOR = "button, input, a, .MuiCheckbox-root, [role='menuitem'], .MuiPopover-root, .MuiDialog-root"

export function isOrderRowControlClick(target: EventTarget | null): boolean {
    return target instanceof HTMLElement && Boolean(target.closest(ROW_CONTROL_SELECTOR))
}
